export default __webpack_public_path__ + "static/media/LittleFugueInGMinor-JSBach.89c4dd4e.mp3";